export default __webpack_public_path__ + "static/media/black-friday-bg.f5a99acb.svg";